import React, { useEffect } from "react";
import { getAllSongs } from "../api";
import { actionType } from "../Context/reducer";
import { useStateValue } from "../Context/StateProvider";
import Header from "./Header";
import { motion } from "framer-motion";
import { IoMusicalNote } from "react-icons/io5";

const Music = () => {
  const [{ allSongs, song, isSongPlaying }, dispatch] = useStateValue();
  useEffect(() => {
    if (!allSongs) {
      getAllSongs().then((data) => {
        dispatch({
          type: actionType.SET_ALL_SONGS,
          allSongs: data.data,
        });
      });
    }
  }, []);

  const setCurrentPlaySong = (songindex) => {
    if (!isSongPlaying) {
      dispatch({
        type: actionType.SET_SONG_PLAYING,
        isSongPlaying: true,
      });
    }
    if (song !== songindex) {
      dispatch({
        type: actionType.SET_SONG,
        song: songindex,
      });
    }
  };
  return (
    <div>
      <Header />
      <div className="absolute top-[20%] left-4 bottom-24 gap-2 py-2 w-350 max-w-[350px] h-510 max-h-[510px] flex flex-col overflow-y-scroll scrollbar-thin rounded-md shadow-md bg-primary">
        {allSongs.length > 0 ? (
          allSongs.map((music, index) => (
            <motion.div
              initial={{ opacity: 0, translateX: -50 }}
              animate={{ opacity: 1, translateX: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              className={`group w-full p-4 hover:bg-card flex gap-3 items-center cursor-pointer ${
                music?._id === song._id ? "bg-card" : "bg-transparent"
              }`}
              onClick={() => setCurrentPlaySong(index)}
            >
              <IoMusicalNote className="text-textColor group-hover:text-headingColor text-2xl cursor-pointer" />

              <div className="flex items-start flex-col">
                <p className="text-lg text-headingColor font-semibold">
                  {`${
                    music?.name.length > 20
                      ? music?.name.slice(0, 20)
                      : music?.name
                  }`}{" "}
                  <span className="text-base">({music?.album})</span>
                </p>
                <p className="text-textColor">
                  {music?.artist}{" "}
                  <span className="text-sm text-textColor font-semibold">
                    ({music?.category})
                  </span>
                </p>
              </div>
            </motion.div>
          ))
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
export default Music;
